/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import QuizIcon from '@mui/icons-material/Quiz'
import Tooltip from '@mui/material/Tooltip'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import { useDispatch, useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'
import ModalCargoServicio from '../../ModalCargoServicio'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import '../../../../Styles/App/Pay/Pay.css'
import CardPayRef from '../PaymentComponentRef/CardPayRef'

import { getPagoState } from '../../../../Actions/MundoBarterActions'

let QrCodeAPI =
  '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'

const Codi = ({ QrCodeAPI }) => (
  <img
    style={{ width: '350px', height: '' }}
    src={`data:image/jpeg;base64,${QrCodeAPI}`}
  />
)

const PayRef = (props) => {
  const handleBack = () => {
    props.handleBack()
  }

  const [viewInfo, setViewInfo] = useState(false)
  const handleviewInfo = () => {
    setViewInfo(!viewInfo)
  }

  //Estados visibilidad metodos de pago
  const [card, setCard] = useState(false)

  //estados del toggle btn
  const [alignment, setAlignment] = useState('Card')

  const handleCardView = (event, newAlignment) => {
    setAlignment(newAlignment)
    setCard(!card)
  }
  var data = JSON.parse(sessionStorage.getItem('refrendo'))

  const total = (data) => {
    var montoRefrenar = (data * 20) / 100
    var fee = (montoRefrenar * 2.12) / 100 + 3
    var totalPagar = montoRefrenar + fee
    return totalPagar
  }

  const totalRefrendo = (data) => {
    var montoRefrenar = (data * 20) / 100
    // var fee = ((montoRefrenar * 2.12) / 100) + 3;
    // var totalPagar = montoRefrenar + fee;
    return montoRefrenar
  }

  const [openModalTerminos, setModalTerminos] = useState(false)
  const handleOpenTerminos = () => {
    setModalTerminos(!openModalTerminos)
  }
  const [amountPay, setAmountCodi] = useState({
    monto: 0,
    saldo: props.detalles.dblSaldoActual,
    refrendo: 0,
    fee: 0,
    totalPagar: props.detalles.dblTotalEmpeño,
  })
  const getRefrendo = () => {
    var data = JSON.parse(sessionStorage.getItem('refrendo'))
    console.log('data' + data)
    if (data !== null) {
      setAmountCodi({
        ...amountPay,
        saldo: props.detalles.dblSaldoActual,
        monto: data.refrendo,
        fee: data.fee,
        totalPagar: data.totalPagar,
      })
    }
  }
  useEffect(() => {
    getRefrendo()
  }, [])

  return (
    <div className="CardApartadoDetailPagosCardStepper">
      <div className="BodyCardApartadoDetail">
        <div className="ApartadoDetailSection2"></div>
      </div>

      <div className="boxDetailPurchase  mb3">
        <div className="flex-between">
          <Button
            className="btn-change-amount"
            startIcon={<ChevronLeftIcon />}
            onClick={handleBack}
          >
            Regresar
          </Button>
          <p className="bold">Refrendar empeño</p>
        </div>
      </div>

      <div className="flex head-checkout-PayLiq-1 ">
        <div className="w40 title-checkout-PayLiq">Articulo</div>
        <div className="w30 text-center title-checkout-PayLiq">SubTotal</div>
        <div className="w30 text-center title-checkout-PayLiq">Total</div>
      </div>
      <div className="flex head-checkout-PayLiq-2">
        <div className="w40 subtitle-checkout-PayLiq">
          <strong>
            {props.data.intIdProductos} {props.data.intIdMarca}
          </strong>
        </div>
        <div className="w30 text-center subtitle-checkout-PayLiq">
          <NumberFormat
            value={props.data.dblMontoReferendo === null ? 0 : amountPay.monto}
            displayType={'text'}
            fixedDecimalScale={true}
            decimalScale={2}
            thousandSeparator={true}
            prefix={'$ '}
            suffix={'MXN'}
          />
        </div>
        <div className="w30 text-center subtitle-checkout-PayLiq">
          <NumberFormat
            value={
              props.data.dblMontoReferendo === null ? 0 : amountPay.totalPagar
            }
            displayType={'text'}
            fixedDecimalScale={true}
            decimalScale={2}
            thousandSeparator={true}
            prefix={'$ '}
            suffix={'MXN'}
          />
          <Button
            className="BtnTermConditions2"
            sx={{ padding: '0 !important', minWidth: '0 !important' }}
            onClick={handleOpenTerminos}
          >
            <InfoOutlinedIcon />
          </Button>
        </div>
      </div>
      <CardPayRef props={props.props} />
      <ModalCargoServicio
        openModalImgPreview={openModalTerminos}
        onCloseModalImgPreview={handleOpenTerminos}
      />
    </div>
  )
}

export default PayRef
